import { Col, Row } from 'bee-layout';
require('bee-layout/build/Layout.css');
import HotKeys from '../HotKeys';


const functionList = {
	'#month(0)#': '本月',
	'#day(0)#': '今日'
};

function selectDateFunction(e, callback, item) {
	pickerState(e, false);
	callback({ value: item });
}
function pickerState(e, flag) {
	let pickerDOM = document.getElementsByClassName('rc-calendar-picker')[0];
	if (pickerDOM) {
		pickerDOM.style.display = flag ? 'block' : 'none';
	} else {
	}
}

export const checkFuntionValue = (value) => {
	document.getElementsByClassName('rc-calendar-picker')[0];
	return Object.keys(functionList).indexOf(value) !== -1;
};
export const getTimeFunctionLabel = (value, show) => {
	let label = functionList[value] || '';
	return show && label ? (
		<div className="date-picker-mask" onClick={(e) => pickerState(e, true)}>
			{label}
		</div>
	) : null;
};
// value = 选择的时间 callback = 单击回调 show  = 是否显示时间函数
export const getDateFunNode = (value, callback, show, hiddenFunList) => {
	if (!show) return;
	let newFunList = { ...functionList };
    if (Array.isArray(hiddenFunList)) {
        hiddenFunList.forEach(element => {
            delete newFunList[element];
        });
    }
	let spen = 4;
	return (
		<HotKeys
			keyMap={{
				rightHandler: ["right"],
				leftHandler: ["left"],
				enterHander: ["enter"]
			}}
			handlers={{
				rightHandler: (e) => {
					if (document.activeElement.nextElementSibling) {
						document.activeElement.nextElementSibling.focus();
					}
				},
				leftHandler: () => {
					if (document.activeElement.previousElementSibling) {
						document.activeElement.previousElementSibling.focus();
					}
				},
				enterHander: () => {
					if (document.activeElement) {
						document.activeElement.click();
					}

				}
			}}
			clearOpenPanel={false}
		>
			<Row>
				{Object.keys(newFunList).map((item, index) => (
					<Col
						className="fun-plan-area"
						tabindex={index === 0 ? "0" : "-1"}
						lg={spen}
						md={spen}
						sm={spen}
						xs={spen}
						onClick={(e) => selectDateFunction(e, callback, item)}
						onKeyDown={(e) => {
							e.stopPropagation();
						}}
					>
						<span>{newFunList[item]}</span>
					</Col>
				))}
			</Row>
		</HotKeys>
	);
};
